<template>
    <div>
        <BaseDatatable :module="`books`" :apiurl="url" :fields="fields"></BaseDatatable>
    </div>
</template>

<script>
import BaseDatatable from '../../core/BaseDatatable'

export default {
  name: 'BookList',
  props: ['url'],
  components: {BaseDatatable},
  data () {
    return {
      apiurl: this.url,
      fields: [
        {
          name: 'isbn',
          sortField: 'isbn',
          title: this.$translate.t('ISBN')
        },
        {
          name: 'title',
          sortField: 'title',
          title: this.$translate.t('Name')
        },
        {
          name: 'author',
          sortField: 'author_id',
          title: this.$translate.t('Szerző')
        },
        {
          name: 'publisher',
          sortField: 'publisher',
          title: this.$translate.t('Kiadó')
        },
        {
          name: 'sku',
          sortField: 'sku',
          title: this.$translate.t('Árukód')
        },
        {
          name: 'category_formatted',
          title: this.$translate.t('Kategória')
        },
        {
          name: 'price_formatted',
          sortField: 'price',
          title: this.$translate.t('Ár')
        },
        {
          name: 'calculate',
          title: this.$translate.t('Összes / Megrendelt')
        },
        {
          name: '__slot:actions',
          title: this.$translate.t('Actions')
        }
      ],
      roles: {},
      page: 1,
      filters: {}
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Book List'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/book/BookList.vue